<template>
  <button
    v-if="$slots['icon-handler']"
    :ref="(el) => setRefButton(el)"
    class="single-lang-btn"
    :is-open="isOpen"
    :data-off="isDataOff"
    @click="onClick"
  >
    <slot name="icon-handler" />
  </button>
</template>

<script setup lang="ts">
const {
  onClick,
  isDataOff = true,
  isOpen = false,
  setRefButton = () => {},
} = defineProps<{
  isMic?: boolean; // 마이크 버튼인지
  textButton?: string; // 아이콘 하단 문구
  classButton?: string; // 버튼의 클래스
  isDataOff?: boolean; // data-off 여부
  isOpen?: boolean; // 드랍다운 오픈
  onClick?: () => void; // 버튼 클릭 시 실행되는 함수
  setRefButton?: (el: HTMLElement) => void; // 버튼의 ref 설정을 위한 함수
}>();
</script>

<style scoped lang="scss">
.button-handler {
  display: flex;
  flex-direction: row;
  position: relative;
  align-items: center;
  justify-content: center;
  background-color: var(--surface-default);
  width: fit-content;
  padding: 0.25rem 1rem;
  border-radius: 8px;
  transition: background-color 0.75s ease;
  z-index: 1000;
}

.button-handler:hover {
  background-color: var(--surface-hover);
}

.single-lang-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: $size-m;
  padding: 0.25rem 0.75rem;
  border-radius: $size-s;
  background: $primary-bg;
  transition: all 0.1s ease;
  &:hover {
    background: $primary-bg-hover;
  }
}
</style>
